import { ROUTES } from "./siteConfig";

export const costPages = {
  webdesign: {
    path: "/webdesign-kosten-oesterreich",
    title: "Webdesign Kosten Österreich",
    metaTitle: "Webdesign Kosten Österreich | Was kostet eine professionelle Website?",
    metaDescription:
      "Webdesign Kosten in Österreich: Orientierung zu Preisen für Websites, One-Pager, Mehrseiten und Relaunch. Transparente Informationen für KMU.",
    h1: "Webdesign Kosten Österreich – Was kostet eine professionelle Website?",
    intro:
      "Die Kosten für eine Website hängen von Umfang, Design und Funktionalität ab. Wir geben Ihnen eine Orientierung, was Sie in Österreich für professionelles Webdesign einplanen können – und was den Preis beeinflusst.",
    sections: [
      {
        title: "Schritt für Schritt: Was beeinflusst die Webdesign-Kosten?",
        content:
          "Seitenanzahl und Struktur, individuelles Design vs. Template, Texte (von uns oder von Ihnen), Bilder und Fotos, Zusatzfunktionen (Formulare, Buchungssysteme, Mehrsprachigkeit), Wartung und Hosting. Ein klares Briefing und eine definierte Zielgruppe helfen, den Rahmen zu halten.",
      },
      {
        title: "Richtwerte für Webdesign in Österreich",
        content:
          "Ein einfacher One-Pager oder eine kleine Website mit wenigen Seiten liegt oft im unteren bis mittleren vierstelligen Bereich. Größere Projekte mit individuellem Design, vielen Seiten und Zusatzfunktionen können im fünfstelligen Bereich liegen. Wir erstellen nach einer Erstberatung ein unverbindliches Angebot.",
      },
      {
        title: "Experten-Tipp: Investition vs. laufende Kosten",
        content:
          "Neben der einmaligen Erstellung fallen Hosting, Domain und optional Wartung oder Content-Pflege an. Wir planen mit Ihnen gemeinsam, was langfristig sinnvoll ist.",
      },
    ],
    faqs: [
      {
        q: "Wie viel kostet eine Website in Österreich ungefähr?",
        a: "Einfache Websites (z. B. 5–10 Seiten, Standard-Design) liegen oft zwischen etwa 2.000 und 6.000 Euro. Komplexere Projekte mit individuellem Design und vielen Funktionen können darüber liegen. Ein Angebot erhalten Sie nach einem unverbindlichen Gespräch.",
      },
      {
        q: "Website erstellen lassen vs. selbst bauen – was lohnt sich?",
        a: "Baukastensysteme sind günstig, aber oft limitiert in Design und SEO. Eine professionell entwickelte Website bringt individuelle Gestaltung, bessere Suchmaschinen-Optimierung und technische Stabilität – ideal für Unternehmen, die langfristig sichtbar sein wollen.",
      },
    ],
    relatedLinks: [
      { label: "Webdesign", path: ROUTES.serviceWebdesign },
      { label: "Website Relaunch", path: ROUTES.serviceRelaunch },
      { label: "Branding Kosten Österreich", path: ROUTES.costBranding },
    ],
  },
  branding: {
    path: "/branding-kosten-oesterreich",
    title: "Branding Kosten Österreich",
    metaTitle: "Branding Kosten Österreich | Was kostet Markenentwicklung?",
    metaDescription:
      "Branding und Markenentwicklung: Orientierung zu Kosten für Logo, Corporate Design und Markenstrategie in Österreich.",
    h1: "Branding Kosten Österreich – Was kostet Markenentwicklung?",
    intro:
      "Die Kosten für Branding und Markenentwicklung variieren stark – je nachdem, ob Sie nur ein Logo, ein vollständiges Corporate Design oder eine komplette Markenstrategie benötigen. Wir geben eine Orientierung für den österreichischen Markt.",
    sections: [
      {
        title: "Was kann Branding umfassen?",
        content:
          "Logo-Entwicklung, Farben und Typografie, Anwendungen (Visitenkarte, Briefbogen, Website, Social Media), CD-Handbuch und optional Namensfindung oder Positionierung. Der Umfang bestimmt maßgeblich die Kosten.",
      },
      {
        title: "Richtwerte für Branding in Österreich",
        content:
          "Ein neues Logo allein liegt oft im unteren bis mittleren vierstelligen Bereich. Ein vollständiges Corporate Design inklusive Anwendungen und Handbuch kann im mittleren bis oberen vierstelligen oder niedrigen fünfstelligen Bereich liegen. Wir erstellen ein individuelles Angebot nach Ihren Anforderungen.",
      },
    ],
    faqs: [
      {
        q: "Was ist im Branding-Preis enthalten?",
        a: "Das hängt vom Projekt ab. Typisch sind: Logo-Varianten, Farb- und Schriftdefinitionen, Anwendungsbeispiele und ein Handbuch. Zusatzleistungen wie Website oder Printproduktion werden separat kalkuliert.",
      },
    ],
    relatedLinks: [
      { label: "Branding", path: ROUTES.serviceBranding },
      { label: "Corporate Design", path: ROUTES.serviceCorporateDesign },
      { label: "Webdesign Kosten Österreich", path: ROUTES.costWebdesign },
    ],
  },
  socialMedia: {
    path: "/social-media-betreuung-kosten-oesterreich",
    title: "Social Media Betreuung Kosten Österreich",
    metaTitle: "Social Media Betreuung Kosten Österreich | Preise & Umfang",
    metaDescription:
      "Social Media Betreuung Kosten in Österreich: Orientierung zu Preisen für Kanäle, Content und Community-Management. Transparente Informationen für Unternehmen.",
    h1: "Social Media Betreuung Kosten Österreich – Was kostet die Betreuung?",
    intro:
      "Die Kosten für Social Media Betreuung hängen vom Umfang ab: Anzahl der Kanäle, Posting-Frequenz, Erstellung von Inhalten und Community-Management. Wir geben eine Orientierung für den österreichischen Markt.",
    sections: [
      {
        title: "Was beeinflusst die Kosten für Social Media Betreuung?",
        content:
          "Anzahl und Auswahl der Plattformen (z. B. LinkedIn, Instagram, Facebook), Häufigkeit der Beiträge, Erstellung von Texten und Bildern, Community-Management und optional Werbebudget. Wir erstellen nach einer unverbindlichen Beratung ein transparentes Angebot.",
      },
      {
        title: "Richtwerte für Social Media Betreuung in Österreich",
        content:
          "Kleine Pakete mit einem Kanal und wenigen Posts pro Woche liegen oft im unteren bis mittleren dreistelligen Bereich monatlich. Umfangreichere Betreuung mit mehreren Kanälen und höherer Frequenz kann im oberen dreistelligen bis unteren vierstelligen Bereich monatlich liegen.",
      },
    ],
    faqs: [
      {
        q: "Wie viel kostet Social Media Betreuung in Österreich?",
        a: "Die Kosten variieren stark: von einigen hundert Euro monatlich für eine schlanke Betreuung bis zu deutlich mehr für mehrere Kanäle, hohe Frequenz und Content-Erstellung. Wir beraten Sie unverbindlich und erstellen ein passendes Angebot.",
      },
    ],
    relatedLinks: [
      { label: "Social Media Marketing", path: ROUTES.socialMediaMarketing },
      { label: "Digitale Vermarktung", path: ROUTES.digitaleVermarktung },
      { label: "Marketing Agentur Kärnten", path: ROUTES.marketingKaernten },
    ],
  },
};
